<template>
  <v-container class="lobby-promotions" pa-0>
    <v-layout align-start wrap>
      <v-flex sm12 md9 pa-0>
        <v-layout wrap>
          <v-flex md7 sm12>
            <ArticleTip
              :item="articleOfTheWeek"
              :height="'290px'"
              :darkMode="true"
              :highlight="articleOfTheWeekHighlight"
              :isVideo="false"
            />
          </v-flex>
          <v-flex md5 sm12 pl-md-6>
            <ArticleTip
              :item="promotedArticle"
              :height="'321px'"
              :isVideo="false"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md3 sm12 pa-0 pr-3 pr-md-0>
        <GuideTips :items="guides" :highlight="guideTipsHighlight" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ArticleTip from '@/components/Articles/ArticleTip';
import GuideTips from '@/components/Articles/GuideTips';

export default {
  components: {
    ArticleTip,
    GuideTips,
  },
  data() {
    return {};
  },
  props: {
    articleOfTheWeek: {
      type: Object,
      required: false,
      default: () => {},
    },
    promotedArticle: {
      type: Object,
      required: false,
      default: () => {},
    },
    guides: {
      type: Array,
      required: false,
      default: () => {},
    },
    articleOfTheWeekHighlight: {
      type: String,
      required: false,
      default: '',
    },
    guideTipsHighlight: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

